/**
 * @file 教师上课端导航配置
 * permission 缺失表示所有登录用户可见；没有对应权限码的项不会渲染（不显示灰色假按钮）。
 * 「D2」角标的是已排期但尚未交付的业务页面，点击后进入统一占位说明页。
 */

import type { NavItem } from '@lexiloop/shared';

/** 教师端左侧导航。 */
export const NAV: NavItem[] = [
  { to: '/', label: '工作台' },
  { to: '/students', label: '我的学员', permission: 'user:read', tag: 'D2' },
  { to: '/schedule', label: '我的课表', permission: 'schedule:read', tag: 'D2' },
  { to: '/password', label: '账号安全' },
];
